import Vue from 'vue'
import VueI18n from 'vue-i18n'
import enLocale from './en'
import zhLocale from './zh'
import jaLocale from './ja'
import { localLanguage } from '@/common/storage'

import Url from 'url-parse'

Vue.use(VueI18n)

const messages = {
  en: {
    ...enLocale,
  },
  'zh-cn': {
    ...zhLocale,
  },
  ja: {
    ...jaLocale,
  },
}

const languages = ['zh-cn', 'en', 'ja']
const fallbackLocale = 'zh-cn'

const getLanguage = () => {
  // 优先使用 url 上的 lang 参数
  const query = new Url(location.href, true).query

  let currentLanguage = query.lang || localLanguage.get()

  // 没有默认语言或不支持的语言
  if (!currentLanguage || !languages.some((item) => item === currentLanguage)) {
    currentLanguage = fallbackLocale
  }

  return currentLanguage
}

const i18n = new VueI18n({
  locale: getLanguage(), // set locale
  fallbackLocale,
  messages, // set locale messages
  silentTranslationWarn: true, // 去除国际化警告
})

export const t = (
  ...args: [key: VueI18n.Path, values?: VueI18n.Values]
): string => i18n.t(...args) as string

export default i18n
